function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Icon } from '../../../../../foundations/Icon';
import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { Box } from '../../../Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SelectOption = _ref => {
  var {
    children,
    innerProps,
    innerRef,
    isSelected,
    isFocused,
    value,
    data
  } = _ref;
  var styles = useMultiStyleConfig('SelectOption', {
    isSelected,
    isFocused,
    data
  });
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({}, innerProps), {}, {
    ref: innerRef,
    "data-testid": value.toString(),
    __css: styles['optionContainer'],
    children: /*#__PURE__*/_jsxs(Box, {
      __css: styles['option'],
      children: [data.nestedCount > 0 && /*#__PURE__*/_jsx(Box, {
        __css: styles['iconStyle'],
        children: /*#__PURE__*/_jsx(Icon, {
          type: "sub-arrow",
          size: "small",
          color: "inherit"
        })
      }), /*#__PURE__*/_jsxs(Box, {
        __css: styles['textContainer'],
        children: [/*#__PURE__*/_jsx(Box, {
          __css: styles['optionText'],
          children: children
        }), data.description && /*#__PURE__*/_jsx(Box, {
          __css: styles['descriptionText'],
          children: data.description
        })]
      })]
    })
  }));
};
//# sourceMappingURL=SelectOption.js.map